export default [
  {
    path: '/modules/financial/transacoes',
    name: 'transacoesFinanceiras',
    component: () => import('@/views/modules/financial/transacoes/TransacoesFinanceiras.vue'),
    meta: {
      action: ['ROLE_PAGAMENTO_RECEBIMENTO_CONSULTAR'],
      resource: 'ACL',
      pageTitle: 'Transações Financeiras',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Transações Financeiras', active: true },
      ],
    },
  },
  {
    path: '/modules/financial/transacoes/edit/:id',
    name: 'editTransacoes',
    component: () => import('@/views/modules/financial/transacoes/TransacaoForm.vue'),
    meta: {
      action: ['ROLE_PAGAMENTO_RECEBIMENTO_ATUALIZAR'],
      resource: 'ACL',
      pageTitle: 'Editar Transação',
      breadcrumb: [
        { text: 'Financeiro' },
        { text: 'Transações Financeiras', to: { name: 'transacoesFinanceiras' } },
        { text: 'Editar', active: true },
      ],
    },
  },
]
